import React from "react";
import BackHeader from "@components/header/BackHeader";
import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import Image from "@components/item/Image";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import ProductCard from "@components/card/ProductCard";

const ContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  padding: "2rem",

  ".title": {
    fontSize: "2.8rem",
    lineHeight: "4.4rem",
    fontWeight: theme.fontWeight.medium,
  },

  ".desc": {
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: theme.fontWeight.regular,
  },
}));

const ListContainer = styled.div(
  () =>
    ({
      width: "100%",
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      paddingTop: "2rem",
    }) as const,
);

const Event = () => {
  const params = useParams();
  const lang = window.localStorage.getItem("language");
  const { getEventDetail, getEventProductList } = useApiRequest();

  const { data: eventDetail } = useQuery({
    queryKey: ["eventDetail", params.promotionId],
    queryFn: () => getEventDetail(Number(params.promotionId)),
    enabled: !!params.promotionId,
  });

  const { data: eventProductList } = useQuery({
    queryKey: ["eventProductList", params.promotionId],
    queryFn: () => getEventProductList(Number(params.promotionId)),
    enabled: !!params.promotionId,
  });

  return (
    <>
      <BackHeader title="이벤트" />

      <ContentWrapper>
        <span className="title">
          {lang === "en" && eventDetail?.title_en
            ? eventDetail?.title_en
            : eventDetail?.title_ko}
        </span>

        <Image
          src={eventDetail?.thumbnail_url}
          width="100%"
          height="25rem"
          radius={10}
        />

        <span className="desc">
          {(lang === "en" && eventDetail?.introduction_en
            ? eventDetail?.introduction_en
            : eventDetail?.introduction_ko
          )
            ?.split("\n")
            .map((line: any, index: number, arr: string[]) => (
              <React.Fragment key={index}>
                {line}
                {index !== arr.length - 1 && <br />}
              </React.Fragment>
            ))}
        </span>
      </ContentWrapper>

      <ListContainer>
        {eventProductList?.map((product: any) => (
          <ProductCard
            key={product.product_id}
            id={product.product_id}
            brand={
              lang === "en" && product?.brand_name_en
                ? product?.brand_name_en
                : product?.brand_name_ko
            }
            name={
              lang === "en" && product?.product_name_en
                ? product?.product_name_en
                : product?.product_name_ko
            }
            src={product.thumbnail_url}
            price={product.price}
            likeCount={product.like_total}
            chatCount={product.qna_total}
            soldout={product.is_sold_out === 1}
            isLiked={product.is_liked}
            condition={product.product_condition}
            haveLike
          />
        ))}
      </ListContainer>
    </>
  );
};

export default Event;
